module.exports = __webpack_public_path__ + "assets/class-blue.c70dcae0.svg";